import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import SEO from "@/components/SEO";
import LeadForm from "@/components/LeadForm";
import { Skeleton } from "@/components/ui/skeleton";

export default function BlogPost() {
  const { slug } = useParams();
  const [b, setB] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => {
    setB(null); setNotFound(false); window.scrollTo(0, 0);
    api.get(`/blogs/${slug}`).then((r) => setB(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return <div className="max-w-3xl mx-auto px-4 py-32 text-center"><h1 className="font-display text-3xl text-navy">Article Not Found</h1><Link to="/blog" className="text-gold underline mt-4 inline-block">Back to Blog</Link></div>;
  if (!b) return <div className="max-w-3xl mx-auto px-4 py-16 space-y-6"><Skeleton className="h-72 rounded-2xl" /><Skeleton className="h-40" /></div>;

  return (
    <div>
      <SEO title={`${b.title} | Mathura Homes`} description={b.excerpt} image={b.cover_image}
        jsonLd={{ "@context": "https://schema.org", "@type": "Article", headline: b.title, image: b.cover_image, author: { "@type": "Organization", name: "Mathura Homes" } }} />
      <article className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
        <p className="text-sm text-muted-foreground"><Link to="/" className="hover:text-gold">Home</Link> / <Link to="/blog" className="hover:text-gold">Blog</Link></p>
        <span className="text-xs text-gold-dark font-semibold uppercase tracking-wider mt-4 inline-block">{b.category || "Guide"}</span>
        <h1 className="font-display text-3xl md:text-4xl text-navy mt-2 leading-tight">{b.title}</h1>
        <p className="text-sm text-muted-foreground mt-3">By {b.author || "Mathura Homes"}</p>
        <img src={b.cover_image} alt={b.title} className="w-full rounded-2xl mt-6 aspect-[16/9] object-cover" />
        <div className="prose-blog mt-8" dangerouslySetInnerHTML={{ __html: b.body }} />
        <div className="mt-12 p-6 rounded-2xl bg-muted border border-gray-100">
          <h3 className="font-display text-xl text-navy mb-4">Have questions about buying property?</h3>
          <LeadForm variant="quick" leadType="blog_enquiry" sourcePage={`blog:${b.slug}`} redirectThankYou={false} />
        </div>
      </article>
    </div>
  );
}
